"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconCheckCircleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM12.0051 7.81702C12.7325 6.98575 12.6482 5.72222 11.8169 4.99486C10.9857 4.2675 9.72215 4.35173 8.99479 5.183L7.21473 7.21736L6.44937 6.452C5.66832 5.67095 4.40199 5.67095 3.62094 6.452C2.83989 7.23304 2.83989 8.49937 3.62094 9.28042L5.89794 11.5574C6.28935 11.9488 6.82547 12.1605 7.37871 12.1421C7.93194 12.1237 8.4528 11.8768 8.8173 11.4602L12.0051 7.81702Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg',
    stroke: 'currentColor',
    'stroke-width': '2'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM15.5365 8.28027C16.2436 7.43172 16.1289 6.17059 15.2804 5.46346C14.4318 4.75633 13.1707 4.87098 12.4636 5.71953L8.9785 9.90162L7.51853 8.19832C6.79969 7.35967 5.53709 7.26255 4.69844 7.98139C3.85978 8.70023 3.76266 9.96283 4.48151 10.8015L7.4815 14.3015C7.86463 14.7485 8.42522 15.0039 9.0139 14.9999C9.6026 14.9958 10.1596 14.7325 10.5365 14.2803L15.5365 8.28027Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg',
    stroke: 'currentColor',
    'stroke-width': '2'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM18.6 9.19994C19.2628 8.31628 19.0837 7.06268 18.2 6.39994C17.3164 5.73719 16.0628 5.91628 15.4 6.79994L10.8686 12.8418L8.49483 10.1712C7.76099 9.34564 6.49685 9.27128 5.67128 10.0051C4.84572 10.739 4.77136 12.0031 5.50519 12.8287L9.50519 17.3287C9.90403 17.7774 10.4833 18.0232 11.0831 17.9982C11.6829 17.9733 12.2398 17.6802 12.6 17.1999L18.6 9.19994Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg',
    stroke: 'currentColor',
    'stroke-width': '2'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM24.1869 10.9171C24.6935 10.2616 24.5727 9.31956 23.9172 8.81302C23.2617 8.30648 22.3196 8.42726 21.8131 9.08278L14.3553 18.734L10.0607 14.4393C9.47487 13.8535 8.52513 13.8535 7.93934 14.4393C7.35355 15.0251 7.35355 15.9748 7.93934 16.5606L13.4393 22.0606C13.7442 22.3654 14.1654 22.5244 14.5956 22.4969C15.0258 22.4694 15.4233 22.2582 15.6869 21.9171L24.1869 10.9171Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;